import { useEffect, useState } from 'react'

interface GeoInOutNotificationProps {
  onClose: () => void
  message: string
  type: 'in' | 'out'
}

/**
 * エリア入退出通知を表示するコンポーネント
 */
export default function GeoInOutNotification({ onClose, message, type }: GeoInOutNotificationProps) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const bgColor = type === 'in' ? 'bg-main' : 'bg-blue-600'
  const textColor = type === 'in' ? 'text-sub' : 'text-white'

  return (
    <div className="fixed inset-x-0 bottom-20 z-50 flex items-end justify-center p-4 pb-6 pointer-events-none">
      <div
        className={`${bgColor} ${textColor} rounded-2xl shadow-lg p-6 max-w-sm w-full transform transition-all duration-300 pointer-events-auto ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
        }`}
      >
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-bold text-sm">{type === 'in' ? 'エリアへようこそ！' : 'またのお越しを！'}</h3>
          <button
            type="button"
            onClick={() => {
              setIsVisible(false)
              setTimeout(onClose, 300)
            }}
            className={`${textColor} hover:opacity-70 transition-opacity`}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p className={`${textColor} text-sm`}>{message}</p>
      </div>
    </div>
  )
}
